import {useCallback, useEffect, useState} from 'react';
import RootStore from '../mobx/RootStore';
import {getApplicationData, updateApplicationData as updateData} from '../../Agent/Quotes/api/instantIul';

export function useApplicationData() {
    const customerId = RootStore.agentPortalStore.parameterStore.formid;
    const [applicationData, setApplicationData] = useState<any>();

    const fetchApplicationData = useCallback(async () => {
        if (customerId) {
            const fetchedData = await getApplicationData(customerId);
            setApplicationData(fetchedData);
            return fetchedData;
        }
    }, [customerId]);

    const updateApplicationData = useCallback(
        async (input: any, formId?: string, options?: {mergeWithCurrent?: boolean}) => {
            const id = formId ?? customerId;
            if (id) {
                const mergeWithCurrent = options?.mergeWithCurrent ?? true; // Default to current behavior

                const dataToSend = mergeWithCurrent
                    ? {...applicationData, ...input} // Current behavior
                    : input; // New behavior

                const updatedData = await updateData(id, dataToSend);
                setApplicationData(updatedData);
            }
        },
        [applicationData, customerId],
    );

    useEffect(() => {
        fetchApplicationData();
    }, [fetchApplicationData, customerId]);

    return {
        applicationData,
        updateApplicationData,
        refetch: fetchApplicationData,
    };
}
